import { StudentSkillStates } from '../models/StudentSkillState';
import { TargetGroup } from '../models/TargetGroup';
import { TargetSkillTypeLabel } from '../models/TargetSkillType';

export const filterWithoutExtensionSkills = (
  elements: StudentSkillStates[],
  targetGroupRedux: TargetGroup | undefined,
): StudentSkillStates[] => {
  return elements.filter(element => {
    const targetSkills =
      element.skill.targetSkills?.filter(el => el.target.targetGroup?.id === targetGroupRedux?.id) || [];
    const nonExtensionSkills = targetSkills.filter(el => el.targetSkillType.name !== TargetSkillTypeLabel.EXTENSION);
    return nonExtensionSkills.length > 0 || targetSkills.length === 0;
  });
};
